const initialState = {
  primaryEventData: {},
  selectedCategory: {},
  attendeesDetails: [],
  bookingData: null,
  temporaryBookingState: {},
  priceBreakup: null,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch (type) {
    case "PRIMARY_EVENT_DATA:SET":
      return {
        ...state,
        primaryEventData: data,
      };
    case "SELECTED_CATEGORY:SET":
      return {
        ...state,
        selectedCategory: data,
      };
    case "ATTENDEES_DETAILS:SET":
      return {
        ...state,
        attendeesDetails: data,
      };
    case "SELECTED_STATE_DATA:SET":
      return{
        ...state,
        selectedStateData: data,
      };
    case "BOOKING_DATA:SET":
      return {
        bookingData: data,
      };
    case "TEMPORARY:BOOKING_DATA:SET":
      return {
        ...state,
        temporaryBookingState: data,
      };
    case "PRICE_BREAKUP:SET":
      return {
        ...state,
        priceBreakup: data,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        primaryEventData: {},
        selectedCategory: {},
        attendeesDetails: [],
        bookingData: null, 
        temporaryBookingState: null,
        priceBreakup: null,
      };
    case "BOOKING_DATA:CLEAR":
      return {
        primaryEventData: {},
        selectedCategory: {},
        attendeesDetails: [],
        bookingData: null, 
        temporaryBookingState: null,
        priceBreakup: null,
      }
    default:
      return state;
  }
};
